import { useEffect, useRef } from 'react';
import { initDatadog } from './initDatadog';

export function useDatadog() {
  const isInitializedRef = useRef(false);
  const intervalRef = useRef<number | null>(null);

  useEffect(() => {
    const checkAndInitDatadog = () => {
      if (isInitializedRef.current) return;

      initDatadog().catch(console.error);
      isInitializedRef.current = true;

      if (intervalRef.current !== null) clearInterval(intervalRef.current);
    };

    checkAndInitDatadog();
    intervalRef.current = window.setInterval(checkAndInitDatadog, 1000);

    return () => {
      if (intervalRef.current !== null) {
        window.clearInterval(intervalRef.current);
      }
    };
  }, []);
}
